import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=22cd4704&scoped=true&"
import script from "./slider.vue?vue&type=script&lang=js&"
export * from "./slider.vue?vue&type=script&lang=js&"
import style0 from "./slider.vue?vue&type=style&index=0&id=22cd4704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cd4704",
  null
  
)

export default component.exports